export default "__VITE_ASSET__BmH2vh$q__"